// vue-i18n所需要引入的
import { createI18n } from 'vue-i18n/dist/vue-i18n.esm-bundler.js';
import zh from "./zh/index";
import en from "./en/index";

const messages = {
  en: {
    ...en,
  },
  zh: {
    ...zh,
  }
};

const language = sessionStorage.getItem('language') || 'en';
sessionStorage.setItem('language', language);
const i18n = createI18n({
  // Not available in legacy mode 解决报错问题的配置项！！！
  legacy: false,
  // 全局注册 $t方法
  globalInjection: true,
  // 设置初始化语言
  locale: language,
  // 设置备用语言
  fallbackLocale: 'en',
  messages,
});
export { i18n };

